import React, { useContext } from 'react';
import {BrowserRouter as Router, Routes, Route, Navigate, Outlet, useLocation} from 'react-router-dom';
import AuthContext from './modules/AuthContext';

import Tickets from '../../components/pages/Tickets';
import DisabledPage from '../pages/DisabledPage';
import OpenTicket from '../../components/pages/OpenTicket';
import PageNotFound from '../../components/pages/PageNotFound';
import Navbar from '../../components/js/Navbar';
import Home from '../../components/pages/Home';
import Login from '../../components/pages/Login';
import ArchivedTickets from '../pages/ArchivedTickets';
import SignUp from '../../components/pages/SignUp';
import UnauthorizedPage from '../../components/pages/Unauthorized';
import AdminAccountView from '../pages/AdminAccountView';
import StaffHome from '../../components/pages/StaffHome';
import OAuth from '../../components/pages/OAuth';
import AdminHome from '../../components/pages/AdminHome';
import StaffTickets from '../../components/pages/StaffTickets';
import RequestResetPassword from '../pages/RequestResetPassword';
import ResetPassword from '../pages/ResetPassword';

import Portal from '../../staffSite/pages/Portal';

function RouterComponent() {
    const authContext = useContext(AuthContext);

    const GuestRoute = () => {
        if (authContext.user && authContext.user.status == 'Disabled') {
            return <DisabledPage/>
        } else {
            return <Outlet/>
        }
    }

    const ProtectedRoute = () => {
        if (authContext.user && authContext.user.status == 'Disabled') {
            return <DisabledPage/>
        } else {
            return authContext.user && authContext ? <Outlet/> : <Navigate to={`/login?redirect=${window.location}`} replace/>
        }
    }

    const StaffRoute = () => {
        if (!authContext.user) {
            return <Navigate to={`/login?redirect=${window.location}`} replace/>
        } else {
            return !authContext.user.permissionFlags.IS_STAFF ? <UnauthorizedPage/> : <Outlet/> 
        }
    }

    const AdminRoute = () => {
        return !authContext.user || !authContext.user.permissionFlags.IS_ADMIN ? <UnauthorizedPage/> : <Outlet/>
    }

    const OldDesign = (PageComponent) => {
        return <>
            <Navbar/>
            <div className='home-img'/>
            <PageComponent/>
        </>
    }

    const StaffDesign = (pageName) => {
        return <Portal pageName={pageName}/>
    }

    const StaffRedirect = () => {
        const location = useLocation();

        const newPath = location.pathname.replace(/^\/staff/, '/v2/staff') + location.search;

        return <Navigate to={newPath} replace />;
    } 

    return (
        <>
            <Routes>
                <Route element={<GuestRoute/>}>
                    <Route exact path='/' element={OldDesign(Home)}/>
                    <Route path='/login' element={OldDesign(Login)}/>
                    <Route path='/sign-up' element={OldDesign(SignUp)}/>
                    <Route path='/oauth' element={OldDesign(OAuth)}/>
                    <Route path='/request-reset-password' element={OldDesign(RequestResetPassword)}/>
                    <Route path='/reset-password' element={OldDesign(ResetPassword)}/>
                </Route>

                <Route element={<ProtectedRoute/>}>
                    <Route path='/tickets' element={OldDesign(Tickets)}/>
                    <Route path='/tickets/:id' element={OldDesign(Tickets)}/>
                    <Route path='/openticket' element={OldDesign(OpenTicket)}/>
                    <Route path='/openticket/:id/:topicText' element={OldDesign(OpenTicket)}/>
                </Route>

                <Route path="/staff/*" element={<StaffRedirect/>}/>

                <Route element={<StaffRoute/>}>
                    <Route path='v2/staff/tickets' element={StaffDesign("Tickets")}/>
                    <Route path='v2/staff/archive/tickets' element={StaffDesign("Archive")}/>
                    <Route path='v2/staff/tickets/:ticketId' element={StaffDesign("Tickets")}/>
                    <Route path='v2/staff/archive/tickets/:ticketId' element={StaffDesign("Archive")}/>
                </Route>

                <Route element={<AdminRoute/>}>
                    <Route path='/admin' element={OldDesign(AdminHome)}/>
                    <Route path='/admin/accounts/:id' element={OldDesign(AdminAccountView)}/>
                </Route>
                
                <Route path='*' element={OldDesign(PageNotFound)}/>
            </Routes>
        </>
    );
};

export default RouterComponent;